import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDialogs } from '../../hooks';
import { deleteImport } from '../../utils/api/imports';

const useDeleteImport = ({
  organizationId, showToast, customError, setIsImportsChanged,
}) => {
  const { openDialog, closeDialog } = useDialogs();
  const handleDelete = useCallback((dataToDelete) => {
    deleteImport(organizationId, dataToDelete.id)
      .then((response) => {
        if (!response.ok) {
          showToast({ message: response.statusText || customError, type: 'error' });
        }
        return response.json();
      })
      .then((data) => {
        if (!data || !data.success) {
          showToast({ message: customError, type: 'error' });
          return;
        }
        setIsImportsChanged(true);
        showToast({ message: `${dataToDelete.filename} has been deleted.` || data.message, type: 'success' });
      })
      .catch((error) => {
        showToast({ message: error.message || customError, type: 'error' });
      })
      .finally(() => {
        closeDialog();
      });
  }, [organizationId, showToast, customError, setIsImportsChanged, closeDialog]);

  const deleteImportModal = useCallback((data) => {
    openDialog({
      message: [
        <p className="text-center leading-snug">
          Delete <b>{data.filename}</b> from the import history?
          Any imported data will remain on the site.
        </p>,
      ],
      show: true,
      actions: [
        {
          label: 'Cancel',
          variant: 'secondary',
          onClick: closeDialog,
        },
        {
          label: 'Delete file',
          onClick: () => handleDelete(data),
        },
      ],
    });
  }, [openDialog, closeDialog, handleDelete]);

  return (
    [deleteImportModal]
  );
};

useDeleteImport.propTypes = {
  organizationId: PropTypes.string.isRequired,
  showToast: PropTypes.func.isRequired,
  customError: PropTypes.string.isRequired,
  setIsImportsChanged: PropTypes.func.isRequired,
};

export default useDeleteImport;
